module.exports = __webpack_public_path__ + "static/media/TOEFL_exam.1b9a9bcb.png";